// The actual "pop up" for a new support ticket. Inline-styled on purpose: no
// notification-item-style CSS exists anywhere in this app for these dropdown
// classes (checked — Header.jsx's notification-item classes render unstyled
// today), so this doesn't lean on shared CSS that may not be there.

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { subscribeTicketToasts, dismissTicketToast } from '../store/ticketToastStore';

const AUTO_DISMISS_MS = 10000;

export default function TicketAlertToast() {
  const [toasts, setToasts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => subscribeTicketToasts(setToasts), []);

  useEffect(() => {
    const timers = toasts.map((t) =>
      setTimeout(() => dismissTicketToast(t.id), AUTO_DISMISS_MS)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts]);

  if (!toasts.length) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        maxWidth: 360,
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          onClick={() => {
            dismissTicketToast(t.id);
            navigate('/support');
          }}
          style={{
            display: 'flex',
            gap: 10,
            alignItems: 'flex-start',
            background: '#1f2937',
            border: '1px solid #f59e0b',
            borderRadius: 10,
            padding: '12px 14px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
            cursor: 'pointer',
          }}
        >
          <AlertCircle size={18} color="#f59e0b" style={{ flexShrink: 0, marginTop: 1 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#f9fafb' }}>
              New support ticket
            </div>
            <div
              style={{
                fontSize: 12,
                color: '#d1d5db',
                marginTop: 2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {t.cafeName ? `${t.cafeName} — ` : ''}
              {t.subject}
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              dismissTicketToast(t.id);
            }}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#9ca3af',
              cursor: 'pointer',
              fontSize: 14,
              lineHeight: 1,
              padding: 2,
            }}
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
